// import React, { useState, useEffect } from 'react';
// import { Save, ArrowLeft } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import AdminAppBody from '../../../../components/admin/AdminAppBody';
// import useApiCallHooks from '../../../../hooks/useApiCallHooks';
// import { uiRoutes } from '../../../../routes/ui/uiRoutes';

// const TaskAdd = () => {
//   const navigate = useNavigate();
//   const [programs, setPrograms] = useState([]);
//   const [modules, setModules] = useState([]);
//   const [topics, setTopics] = useState([]);

//   const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

//   const [form, setForm] = useState({
//     program: '',
//     module: '',
//     topic: '',
//     tasks: [{ name: '', description: '' }],
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleTaskChange = (index, field, value) => {
//     const updatedTasks = [...form.tasks];
//     updatedTasks[index][field] = value;
//     setForm((prev) => ({ ...prev, tasks: updatedTasks }));
//   };

//   const handleAddTask = () => {
//     setForm((prev) => ({
//       ...prev,
//       tasks: [...prev.tasks, { name: '', description: '' }],
//     }));
//   };

//   const handleRemoveTask = () => {
//     if (form.tasks.length > 1) {
//       setForm((prev) => ({
//         ...prev,
//         tasks: prev.tasks.slice(0, -1),
//       }));
//     }
//   };

//   const handleSave = async () => {
//     const { program, module, topic, tasks } = form;

//     const payload = {
//       program,
//       module,
//       topic,
//       tasks,
//     };

//     await callAPI('post', 'mentor/create-task', payload);
//   };

//   useEffect(() => {
//     callAPI('get', 'get-program-student-list/student');
//   }, []);

//   useEffect(() => {
//     if (form.program) {
//       callAPI('get', `road-map/${form.program}`);
//     }
//   }, [form.program]);

//   useEffect(() => {
//     if (form.module) {
//       callAPI('get', `module-wise-topic/${form.module}`);
//     }
//   }, [form.module]);

//   useEffect(() => {
//     if (!response?.data) return;

//     const data = response.data;

//     if (Array.isArray(data.programs)) {
//       setPrograms(data.programs);
//     }

//     if (Array.isArray(data) && data[0]?.name && data[0]?.id && response.message === 'RoadMapModules') {
//       setModules(data);
//     }

//     if (Array.isArray(data) && data[0]?.module_id) {
//       setTopics(data);
//     }

//     if (statusCode === 201) {
//       toast.success('Tasks created successfully!');
//       setTimeout(() => navigate("/mentor/task-list"), 2000);
//     }
//   }, [response, statusCode, navigate]);

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="p-4 card shadow-sm">
//           <h5 className="mb-3 fw-bold">Add Task</h5>

//           <div className="row mb-3">
//             <div className="col-md-4">
//               <label className="form-label fw-semibold">Program</label>
//               <select
//                 className="form-select"
//                 name="program"
//                 value={form.program}
//                 onChange={handleChange}
//               >
//                 <option value="">-- Select Program --</option>
//                 {programs.map((p) => (
//                   <option key={p.id} value={p.id}>
//                     {p.name}
//                   </option>
//                 ))}
//               </select>
//               <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.program}
//                 </span>
//             </div>

//             <div className="col-md-4">
//               <label className="form-label fw-semibold">Module</label>
//               <select
//                 className="form-select"
//                 name="module"
//                 value={form.module}
//                 onChange={handleChange}
//                 disabled={!modules.length}
//               >
//                 <option value="">-- Select Module --</option>
//                 {modules.map((m) => (
//                   <option key={m.id} value={m.id}>
//                     {m.name}
//                   </option>
//                 ))}
//               </select>
//               <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.module}
//                 </span>
//             </div>

//             <div className="col-md-4">
//               <label className="form-label fw-semibold">Topic</label>
//               <select
//                 className="form-select"
//                 name="topic"
//                 value={form.topic}
//                 onChange={handleChange}
//                 disabled={!topics.length}
//               >
//                 <option value="">-- Select Topic --</option>
//                 {topics.map((t) => (
//                   <option key={t.id} value={t.id}>
//                     {t.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.topic}
//                 </span>
//           </div>

//           {form.tasks.map((task, index) => (
//             <div key={index} className="mb-3 border p-3 rounded">
//               <label className="form-label fw-semibold">Task {index + 1}</label>
//               <input
//                 className="form-control mb-2"
//                 placeholder="Task Name"
//                 value={task.name}
//                 onChange={(e) => handleTaskChange(index, 'name', e.target.value)}
//               />
//               <textarea
//                 className="form-control"
//                 rows={2}
//                 placeholder="Task Description"
//                 value={task.description}
//                 onChange={(e) => handleTaskChange(index, 'description', e.target.value)}
//               />
//             </div>
//           ))}

//           <div className="d-flex gap-3 mb-3">
//             <button className="btn btn-outline-primary" onClick={handleAddTask}>
//               Add Task
//             </button>
//             <button className="btn btn-danger" onClick={handleRemoveTask}>
//               Remove
//             </button>
//           </div>

//           <div className="d-flex justify-content-end gap-2">
//             <button className="btn btn-primary" onClick={handleSave}>
//               <Save size={16} className="me-1" />
//               Save
//             </button>
//             <button className="btn btn-outline-primary" onClick={() => navigate(-1)}>
//               <ArrowLeft size={16} className="me-1" />
//               Back
//             </button>
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default TaskAdd;


import React, { useState, useEffect } from 'react';
import { Save, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';

const TaskAdd = () => {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [modules, setModules] = useState([]);
  const [topics, setTopics] = useState([]);
  const [type, setType] = useState(""); // <-- New state for type

  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  const [form, setForm] = useState({
    program: '',
    module: '',
    topic: '',
    tasks: [{ name: '', description: '' }],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleTaskChange = (index, field, value) => {
    const updatedTasks = [...form.tasks];
    updatedTasks[index][field] = value;
    setForm((prev) => ({ ...prev, tasks: updatedTasks }));
  };

  const handleAddTask = () => {
    setForm((prev) => ({
      ...prev,
      tasks: [...prev.tasks, { name: '', description: '' }],
    }));
  };

  const handleRemoveTask = () => {
    if (form.tasks.length > 1) {
      setForm((prev) => ({
        ...prev,
        tasks: prev.tasks.slice(0, -1),
      }));
    }
  };

  const handleSave = async () => {
    const { program, module, topic, tasks } = form;

    const payload = {
      type,
      program,
      module,
      topic,
      tasks,
    };

    await callAPI('post', 'mentor/create-task', payload);
  };

  // 🟡 Fetch programs when type changes
  useEffect(() => {
    if (type) {
      callAPI('get', `get-program-student-list/${type}`);
    }
  }, [type]);

  useEffect(() => {
    if (form.program) {
      callAPI('get', `road-map/${form.program}`);
    }
  }, [form.program]);

  useEffect(() => {
    if (form.module) {
      callAPI('get', `module-wise-topic/${form.module}`);
    }
  }, [form.module]);

  useEffect(() => {
    if (!response?.data) return;

    const data = response.data;

    if (Array.isArray(data.programs)) {
      setPrograms(data.programs);
    }

    if (Array.isArray(data) && data[0]?.name && data[0]?.id && response.message === 'RoadMapModules') {
      setModules(data);
    }

    if (Array.isArray(data) && data[0]?.module_id) {
      setTopics(data);
    }

    if (statusCode === 201) {
      toast.success('Tasks created successfully!');
      setTimeout(() => navigate("/mentor/task-list"), 2000);
    }
  }, [response, statusCode, navigate]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="p-4 card shadow-sm">
          <h5 className="mb-3 fw-bold">Add Task</h5>

          {/* 🟢 TYPE DROPDOWN */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold">Type</label>
              <select
                className="form-select"
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                  setForm({ ...form, program: '', module: '', topic: '', tasks: [{ name: '', description: '' }] });
                  setPrograms([]);
                  setModules([]);
                  setTopics([]);
                }}
              >
                <option value="">-- Select Type --</option>
                <option value="kids">Kids</option>
                <option value="student">Student</option>
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">Program</label>
              <select
                className="form-select"
                name="program"
                value={form.program}
                onChange={handleChange}
                disabled={!programs.length}
              >
                <option value="">-- Select Program --</option>
                {programs.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </select>
              <span className="val-message text-danger">
                {error?.message === "ValidationError" && error?.data?.program}
              </span>
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">Module</label>
              <select
                className="form-select"
                name="module"
                value={form.module}
                onChange={handleChange}
                disabled={!modules.length}
              >
                <option value="">-- Select Module --</option>
                {modules.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
              </select>
              <span className="val-message text-danger">
                {error?.message === "ValidationError" && error?.data?.module}
              </span>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold">Topic</label>
              <select
                className="form-select"
                name="topic"
                value={form.topic}
                onChange={handleChange}
                disabled={!topics.length}
              >
                <option value="">-- Select Topic --</option>
                {topics.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                ))}
              </select>
              <span className="val-message text-danger">
                {error?.message === "ValidationError" && error?.data?.topic}
              </span>
            </div>
          </div>

          {form.tasks.map((task, index) => (
            <div key={index} className="mb-3 border p-3 rounded">
              <label className="form-label fw-semibold">Task {index + 1}</label>
              <input
                className="form-control mb-2"
                placeholder="Task Name"
                value={task.name}
                onChange={(e) => handleTaskChange(index, 'name', e.target.value)}
              />
              <textarea
                className="form-control"
                rows={2}
                placeholder="Task Description"
                value={task.description}
                onChange={(e) => handleTaskChange(index, 'description', e.target.value)}
              />
            </div>
          ))}

          <div className="d-flex gap-3 mb-3">
            <button className="btn btn-outline-primary" onClick={handleAddTask}>
              Add Task
            </button>
            <button className="btn btn-danger" onClick={handleRemoveTask}>
              Remove
            </button>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-primary" onClick={handleSave}>
              <Save size={16} className="me-1" />
              Save
            </button>
            <button className="btn btn-outline-primary" onClick={() => navigate(-1)}>
              <ArrowLeft size={16} className="me-1" />
              Back
            </button>
          </div>
        </div>
      }
    />
  );
};

export default TaskAdd;
